import type { ComponentType } from 'react';
import type { PageSection } from '@solote/contracts';

/**
 * REGISTRY DE SECOES
 *
 * A home (Cap. 5.1) e as paginas do CMS sao listas de secoes escolhidas no
 * painel. Cada `kind` mapeia para um componente registrado aqui. O
 * administrador reordena, liga e desliga blocos; o desenvolvedor so aparece
 * quando um TIPO novo de bloco e necessario.
 */

export type SectionComponentProps = {
  section: PageSection;
  /** Contexto da pagina — cidade, estado, aptidao — usado por secoes segmentadas. */
  pageContext: Record<string, string | undefined>;
};

export type SectionComponent = ComponentType<SectionComponentProps>;

const registry = new Map<string, SectionComponent>();

export function registerSection(kind: string, component: SectionComponent): void {
  registry.set(kind, component);
}

export function resolveSection(kind: string): SectionComponent | null {
  return registry.get(kind) ?? null;
}

export function listRegisteredSections(): string[] {
  return [...registry.keys()].sort();
}
